import React from 'react';
import InfoIcon from 'swag-client-common/components/icons/info-icon/info-icon';
import { Tooltip } from 'swag-client-common/components/info/tooltip';
import { Price } from 'swag-client-common/utils/price';
const PriceRow = ({
  dataText,
  value,
  title,
  mode,
  text,
  placement,
  textClassName,
  rowClassName,
  priceClassName,
  infoButtonClassName,
  tooltipClassName
}) => /*#__PURE__*/React.createElement("div", {
  className: rowClassName
}, /*#__PURE__*/React.createElement("span", {
  className: textClassName
}, text), /*#__PURE__*/React.createElement("span", {
  className: priceClassName
}, /*#__PURE__*/React.createElement("span", {
  "data-text": dataText
}, Price.formatPrice(value)), /*#__PURE__*/React.createElement(Tooltip, {
  title: title,
  placement: placement,
  mode: mode,
  className: tooltipClassName
}, /*#__PURE__*/React.createElement(InfoIcon, {
  className: infoButtonClassName
}))));
export default PriceRow;